import { z } from "zod";

export const RequestListingDataSchema = z.object({
    id: z.string(),
    isSubmitted: z.boolean(),
    generatedDocumentId: z.string().nullish(),
    requestTypeId: z.number().nullish(),
    isMy: z.boolean().nullish(),
    stateTypeId: z.number().nullish(),
    stateEventDate: z.string().nullish(),
    createdDate: z.string(),
    sourceTypeId: z.number().nullish(),
    sourceId: z.number().nullish(),
    reasoning: z.string().nullish(),
    partner: z.string().nullish(),
    partnerId: z.number().nullish(),
    partnerEmail: z.string().nullish(),
    recordTypeId: z.number().nullish(),
    recordId: z.number().nullish(),
});

export type RequestListingData = z.infer<typeof RequestListingDataSchema>;